import { render } from "./NavigationComponent.vue?vue&type=template&id=484b4976"
import script from "./NavigationComponent.vue?vue&type=script&lang=js"
export * from "./NavigationComponent.vue?vue&type=script&lang=js"

import "./NavigationComponent.vue?vue&type=style&index=0&id=484b4976&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__